type MembershipType = 'admin' | 'admin' | 'normal' | 'normal' | 'observer';

export const isMembershipType = (
  membership:
    | { memberType: 'admin' | 'normal' }
    | { memberType: 'admin' | 'normal' | 'observer' },
  membershipType: MembershipType,
): boolean => membership.memberType === membershipType;
